/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiResponse } from "apisauce";

export type GeneralApiProblem =
  /**
   * Times up.
   */
  | { kind: "timeout"; temporary: true }
  /**
   * Cannot connect to the server for some reason.
   */
  | { kind: "cannot-connect"; temporary: true }
  /**
   * The server experienced a problem. Any 5xx error.
   */
  | { kind: "server"; message?: any }
  /**
   * We're not allowed because we haven't identified ourself. This is 401.
   */
  | { kind: "unauthorized"; message?: any }
  /**
   * We don't have access to perform that request. This is 403.
   */
  | { kind: "forbidden"; message?: any }
  /**
   * Unable to find that resource.  This is a 404.
   */
  | { kind: "not-found"; message?: any }
  /**
   * All other 4xx series errors.
   */
  | { kind: "rejected"; message?: any }
  /**
   * Something truly unexpected happened. Most likely can try again. This is a catch all.
   */
  | { kind: "unknown"; temporary: true }
  /**
   * The data we received is not in the expected format.
   */
  | { kind: "bad-data"; message?: any }
  | { kind: "bad-request"; message?: any }
  /**
   * The request is canceled.
   */
  | { kind: "cancel" };

/**
 * Attempts to get a common cause of problems from an api response.
 *
 * @param response The api response.
 */
export function getGeneralApiProblem(
  response: ApiResponse<unknown>
): GeneralApiProblem | void | null {
  // eslint-disable-next-line default-case
  switch (response.problem) {
    case "CONNECTION_ERROR":
      return { kind: "cannot-connect", temporary: true };
    case "NETWORK_ERROR":
      return { kind: "cannot-connect", temporary: true };
    case "TIMEOUT_ERROR":
      return { kind: "timeout", temporary: true };
    case "SERVER_ERROR":
      return { kind: "server" };
    case "UNKNOWN_ERROR":
      return { kind: "unknown", temporary: true };
    case "CLIENT_ERROR":
      switch (response.status) {
        case 400:
          return { kind: "bad-request", message: response.data };
        case 401:
          return { kind: "unauthorized" };
        case 403:
          return { kind: "forbidden" };
        case 404:
          return { kind: "not-found" };
        case 422:
          return { kind: "bad-data", message: response.data };
        default:
          return { kind: "rejected" };
      }
    case "CANCEL_ERROR":
      return { kind: "cancel" };
  }

  return null;
}
